import { createFileRoute } from '@tanstack/react-router';

import { SyncCenterPage } from '@/features/sync-center/sync-center-page';

export const Route = createFileRoute('/_app/sync')({ component: SyncCenterPage });
